const defaultAvatar = new URL("../../assets/default-avatar.png", import.meta.url).href;

function firstDefined(...values) {
  return values.find((value) => value !== undefined && value !== null);
}

function firstNonEmptyString(...values) {
  return values.find((value) => typeof value === "string" && value.trim()) || "";
}

function toArray(data) {
  if (Array.isArray(data)) return data;
  return data?.results || data?.items || data?.messages || data?.conversations || [];
}

function buildSenderProfile(item) {
  return firstDefined(
    item.sender_profile,
    item.senderProfile,
    item.sender,
    item.profile,
    item.author,
    item.user,
    {},
  ) || {};
}

export function getConversationListItems(data) {
  return toArray(data);
}

export function getMessageListItems(data) {
  return toArray(data);
}

export function appendMessageItem(collection, message) {
  if (Array.isArray(collection)) return [...collection, message];
  if (collection?.items && Array.isArray(collection.items)) {
    return { ...collection, items: [...collection.items, message] };
  }
  if (collection?.results && Array.isArray(collection.results)) {
    return { ...collection, results: [...collection.results, message] };
  }
  if (collection?.messages && Array.isArray(collection.messages)) {
    return { ...collection, messages: [...collection.messages, message] };
  }
  return [message];
}

export function normalizeConversation(item) {
  return {
    id: String(firstDefined(item.id, item.conversation_id, item.conversationId, "")),
    name: firstNonEmptyString(
      item.display_name,
      item.displayName,
      item.name,
      item.title,
      item.conversation_name,
      item.conversationName,
      item.peer_name,
      item.peerName,
    ) || "未命名会话",
    avatar: firstNonEmptyString(
      item.avatar_url,
      item.avatarUrl,
      item.avatar,
      item.peer_avatar_url,
      item.peerAvatarUrl,
      item.sender_avatar_url,
      item.senderAvatarUrl,
    ) || defaultAvatar,
    preview: firstNonEmptyString(
      item.last_message_preview,
      item.lastMessagePreview,
      item.preview,
      item.latest_message_preview,
      item.latestMessagePreview,
      item.last_message_text,
      item.lastMessageText,
      item.message_preview,
      item.messagePreview,
      item.summary,
      item.text,
    ) || "暂无消息",
    time: firstDefined(
      item.last_message_at,
      item.lastMessageAt,
      item.time,
      item.latest_at,
      item.latestAt,
      item.updated_at,
      item.updatedAt,
      "",
    ),
    unread: Number(firstDefined(item.unread_count, item.unreadCount, item.unread, 0)),
    peerReadSeq: Number(firstDefined(
      item.peer_last_read_seq,
      item.peerLastReadSeq,
      item.peer_read_seq,
      item.peerReadSeq,
      item.read_seq,
      item.readSeq,
      0,
    )),
    support: Boolean(firstDefined(item.is_support, item.isSupport, item.support, false)),
    type: firstNonEmptyString(item.type, item.conversation_type, item.conversationType, item.kind) || "user",
  };
}

export function normalizeMessage(item, currentUserId) {
  const senderProfile = buildSenderProfile(item);
  const senderId = firstDefined(
    item.sender_user_id,
    item.senderUserId,
    item.sender_id,
    item.senderId,
    senderProfile.user_id,
    senderProfile.userId,
    senderProfile.id,
    "",
  );
  const sentByFlag = firstDefined(item.sent, item.is_sent, item.isSent, item.mine, item.is_mine);
  const normalizedSenderId = senderId ? String(senderId) : "";
  return {
    id: String(firstDefined(
      item.id,
      item.client_message_id,
      item.clientMessageId,
      item.local_id,
      item.localId,
      crypto.randomUUID(),
    )),
    conversationId: String(firstDefined(item.conversation_id, item.conversationId, item.chat_id, item.chatId, "")),
    seq: firstDefined(item.seq, item.sequence, item.message_seq, item.messageSeq, 0),
    text: firstDefined(
      item.text,
      item.text_content,
      item.textContent,
      item.content,
      item.body,
      item.message,
      item.message_text,
      item.messageText,
      "",
    ),
    senderId: normalizedSenderId,
    senderName: firstNonEmptyString(
      item.sender_name,
      item.senderName,
      senderProfile.nickname,
      senderProfile.username,
      senderProfile.display_name,
      senderProfile.displayName,
      senderProfile.name,
    ) || "用户",
    avatar: firstNonEmptyString(
      item.sender_avatar_url,
      item.senderAvatarUrl,
      senderProfile.avatar_url,
      senderProfile.avatarUrl,
      senderProfile.avatar,
    ) || defaultAvatar,
    sent: typeof sentByFlag === "boolean" ? sentByFlag : normalizedSenderId === String(currentUserId),
    createdAt: firstDefined(
      item.created_at,
      item.createdAt,
      item.sent_at,
      item.sentAt,
      item.time,
      item.timestamp,
      "",
    ),
  };
}

export function getEnvelopeConversationId(envelope) {
  return String(firstDefined(
    envelope?.conversationId,
    envelope?.conversation_id,
    envelope?.payload?.conversationId,
    envelope?.payload?.conversation_id,
    envelope?.payload?.conversation?.id,
    envelope?.payload?.chatId,
    envelope?.payload?.chat_id,
    "",
  ));
}

export function getEnvelopeSenderId(envelope) {
  return String(firstDefined(
    envelope?.payload?.senderUserId,
    envelope?.payload?.sender_user_id,
    envelope?.payload?.senderId,
    envelope?.payload?.sender_id,
    envelope?.payload?.sender?.id,
    envelope?.payload?.sender_profile?.userId,
    envelope?.payload?.sender_profile?.user_id,
    envelope?.payload?.senderProfile?.userId,
    envelope?.payload?.senderProfile?.user_id,
    "",
  ));
}

export function getReadReceiptConversationId(payload) {
  return String(firstDefined(
    payload?.conversation_id,
    payload?.conversationId,
    payload?.chat_id,
    payload?.chatId,
    "",
  ));
}

export function getReadReceiptUserId(payload) {
  return String(firstDefined(payload?.user_id, payload?.userId, payload?.reader_id, payload?.readerId, ""));
}

export function getReadReceiptSeq(payload) {
  return Number(firstDefined(
    payload?.last_read_seq,
    payload?.lastReadSeq,
    payload?.read_seq,
    payload?.readSeq,
    0,
  ));
}
